import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';

const initialState = {
    enableAndDisableDeviceSteeringLoading: false,
    enableAndDisableDeviceSteeringSuccess: false,
    enableAndDisableDeviceSteeringFailed: false,
    deviceSteering: [],
    pollingExpiresAt: null,
    deviceSteeringSuccess: false,
    deviceSteeringFailed: false,
    deviceSteeringLoading: false,
    error: null,
    pollDeviceSteeringLoading: false,
    pollDeviceSteeringSuccess: false,
    pollDeviceSteeringFailed: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_STEERING_EXPIRES_AT:
            return {
                ...state,
                pollingExpiresAt: action.timestamp
            }
        case actionTypes.STOP_DEVICE_STEERING_POLLING:
            return {
                ...state,
                pollingExpiresAt: null,
            }
        case actionTypes.DEVICE_STEERING_PUT_DELETE_LOADING:
            return updateObject(state, {
                enableAndDisableDeviceSteeringLoading: true,
                enableAndDisableDeviceSteeringFailed: false,
                enableAndDisableDeviceSteeringSuccess: false
            });
        case actionTypes.DEVICE_STEERING_PUT_DELETE_SUCCESS:
            return updateObject(state, {
                enableAndDisableDeviceSteeringLoading: false,
                enableAndDisableDeviceSteeringFailed: false,
                enableAndDisableDeviceSteeringSuccess: true
            });
        case actionTypes.DEVICE_STEERING_PUT_DELETE_FAILED:
            return {
                ...state,
                enableAndDisableDeviceSteeringLoading: false,
                enableAndDisableDeviceSteeringFailed: true,
                enableAndDisableDeviceSteeringSuccess: false,
                error: action.error
            }
        case actionTypes.GET_DEVICE_STEERING_LOADING:
            return updateObject(state, {
                deviceSteering: [],
                deviceSteeringLoading: true,
                deviceSteeringSuccess: false,
                deviceSteeringFailed: false
            });
        case actionTypes.GET_DEVICE_STEERING_SUCCESS:
            return updateObject(state, {
                deviceSteering: action.payload,
                deviceSteeringLoading: false,
                deviceSteeringSuccess: true,
                deviceSteeringFailed: false
            });
        case actionTypes.GET_DEVICE_STEERING_FAILED:
            return updateObject(state, {
                deviceSteering: [],
                deviceSteeringLoading: false,
                deviceSteeringSuccess: false,
                deviceSteeringFailed: true
            });
        case actionTypes.RESET_DEVICES_STEERING_ERROR_SUCCESS:
            return updateObject(state, {
                enableAndDisableDeviceSteeringFailed: false,
                enableAndDisableDeviceSteeringSuccess: false,
                enableAndDisableDeviceSteeringLoading: false,
                pollDeviceSteeringSuccess: false,
                pollDeviceSteeringFailed: false
            });
        case actionTypes.START_DEVICE_STERING_ALL_POLLING_LOADING:
            return updateObject(state, {
                pollDeviceSteeringLoading: action.isLoading
            });
        case actionTypes.START_DEVICE_STERING_ALL_POLLING_SUCCESS:
            return updateObject(state, {
                pollDeviceSteeringLoading: false,
                pollDeviceSteeringSuccess: true,
                pollDeviceSteeringFailed: false
            });
        case actionTypes.START_DEVICE_STERING_ALL_POLLING_FAILED:
                return updateObject(state, {
                    pollDeviceSteeringLoading: false,
                    pollDeviceSteeringSuccess: false,
                    pollDeviceSteeringFailed: true
                });
        case actionTypes.STOP_DEVICE_STEERING:
            return { ...initialState }
        default: return state;
    }
}

export default reducer;